module.exports = __webpack_public_path__ + "static/img/1.adbbea49.png";